import LocationSearch, { DEFAULT_OPTIONS } from 'CoreComponents/locationSearch';

document.querySelectorAll(DEFAULT_OPTIONS['selector']).forEach(locationSearchInput => {
  new LocationSearch(locationSearchInput);
});
